import Script from "next/script";

export default function SenjaTestimonials() {
  return (
    <div id="senja-testimonials">
      <div
        className="senja-embed"
        data-id="56471041-5fc7-4654-a5fd-32d05768ba4d"
        data-mode="shadow"
        data-lazyload="false"
      ></div>
      <Script
        src="https://widget.senja.io/widget/56471041-5fc7-4654-a5fd-32d05768ba4d/platform.js"
        strategy="lazyOnload"
      />
    </div>
  );
}
